import React from "react";
import "./ErrorOverlay.scss";

const ErrorOverlay: React.FunctionComponent<any> = () => {
    return (
      <div 
        className="ErrorOverlay"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="error-overlay-title"
        aria-describedby="error-overlay-message"
        tabIndex={-1}
      >
        <div className="header" id="error-overlay-title">Looks like something went wrong!</div>
      <div className="message"  id="error-overlay-message">We track these errors automatically, but if the problem persists, feel free to contact us. In the meantime, try refreshing.</div>
      </div>
    )
}

export default ErrorOverlay;
